import { AddIcon, Button, Grid, GridRow } from '@bp/ui-components';
import { FieldArray, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';
import { useAuthClaims } from '../../../../hooks/useAuthClaims';
import { useMemorizedCacheTag } from '../../../../hooks/useMemorizedCacheTag';
import { useSubjectContainersListQuery } from '../../../../types/planung-graphql-client-defs';
import { LessonUnitFormItem } from '../../../Lessons/Forms/LessonUnits/LessonUnitFormItem';
import { LessonFormUnitType } from '../../../Lessons/types';
import { CurriculumFormType } from '../../types';

export const CurriculumUnitForm = () => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const context = useMemorizedCacheTag('SUBJECT_CONTAINER');

  const { values, setFieldTouched } = useFormikContext<CurriculumFormType>();

  const [{ data: subjectContainersData }] = useSubjectContainersListQuery({
    variables: {
      organizationUuid: pimAuthClaims.getOrganizationUuid(),
    },
    context,
  });

  const grades = values.curriculumGrades?.flatMap((lc) => lc.grades);

  const subjectContainers = subjectContainersData?.subjectContainers.filter((sc) => {
    if (sc.grades.length === 0) {
      return true;
    }
    return grades ? grades.every((g) => (g ? sc.grades.includes(g) : false)) : false;
  });

  return (
    <FieldArray name={'lessonUnit'}>
      {(arrayHelpers) => {
        return (
          <Grid useFormGap>
            {values.lessonUnit?.map((lessonUnit, index) => {
              return (
                <LessonUnitFormItem
                  key={lessonUnit.uuid}
                  index={index}
                  subjectContainer={subjectContainers}
                  disabled={false}
                  onDelete={() => arrayHelpers.remove(index)}
                />
              );
            })}

            <GridRow spacingTop='none' spacingBottom='none'>
              <Button
                disabled={!values.subject?.uuid}
                hierarchy='tertiary'
                icon={<AddIcon />}
                onClick={async () => {
                  if (values.lessonUnit && values.lessonUnit.length > 0) {
                    for (const index in values.lessonUnit) {
                      await setFieldTouched(`lessonUnit.${index}`);
                    }
                  }
                  const lessonUnit: LessonFormUnitType = {
                    uuid: uuid(),
                    count: null,
                    factor: null,
                    duration: null,
                    lessonUnitType: 'subjectHour',
                  };
                  arrayHelpers.push(lessonUnit);
                }}
              >
                {t('lessonUnit.add')}
              </Button>
            </GridRow>
          </Grid>
        );
      }}
    </FieldArray>
  );
};
